/**
 * metaLeadGen/creativeType.ts
 *
 * Classifies Meta ad creative type from the ad name.
 * Single source of truth — all creative type logic lives here.
 */

import type { CreativeType } from "./types";

/**
 * Classifies creative type from ad name using keyword matching.
 *
 * Rules (checked in order):
 *   VID or VIDEO  → "Video"
 *   IMG, IMAGE, or STATIC → "Static Image"
 *   CAR or CAROUSEL → "Carousel"
 *   UGC → "UGC"
 *   otherwise → "Other"
 */
export function classifyCreativeType(adName: string): CreativeType {
  // Split on common separators used in ad naming conventions: _ - | space
  const tokens = adName.toUpperCase().split(/[\s_\-|]+/);
  if (tokens.some(t => t === "VID" || t === "VIDEO")) return "Video";
  if (tokens.some(t => t === "IMG" || t === "IMAGE" || t === "STATIC")) return "Static Image";
  if (tokens.some(t => t === "CAR" || t === "CAROUSEL" || t === "CARROUSAL")) return "Carousel";
  if (tokens.some(t => t === "UGC")) return "UGC";
  return "Other";
}

export const ALL_CREATIVE_TYPES: CreativeType[] = [
  "Video",
  "Static Image",
  "Carousel",
  "UGC",
  "Other",
];
